import styled from 'styled-components'

export const Name = styled.div`
  color: 'white';
  fontsize: 12;
`

export const Logo = styled.img`
  width: 30;
  height: 30;
  borderradius: 15;
  marginright: 10;
`

export const Profile = styled.div`
  padding: '24px';
  texttransform: 'uppercase';
  fontweight: 'bold';
  fontsize: 14;
  letterspacing: '1px';
  overflow: 'hidden';
  textoverflow: 'ellipsis';
  whitespace: 'nowrap';
`
